import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { actionActions, getActions, getActionEntities } from "data/actionApi"

class WithActions extends React.Component {
    render() {
        const actionsData = this.props.actions
        if (!actionsData) return this.props.loading ? this.props.loading : ""
        const actions = Object.values(actionsData)

        return this.props.children({
            actions,
            exec: actionActions.exec,
            actionEntities: this.props.entities,
        })
    }

    constructor(props) {
        super(props)
        props.actionActions.fetch()
    }
}

WithActions.propTypes = {}

function mapStateToProps(state) {
    return {
        actions: getActions(state),
        entities: getActionEntities(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actionActions: bindActionCreators(actionActions, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WithActions)



// WEBPACK FOOTER //
// ./src/data/wrappers/WithActions.js